
define('text!templates/components/lead_note/lead_note.html',[],function () { return '<td data-cell="created">\n    <%= user.first_name %> <%= user.last_name %>\n</td>\n\n<td data-cell="created">\n    <%= App.utils.convertToTimezone(created) %>\n</td>\n\n<td data-cell="note">\n    <%= note %>\n</td>\n';});

